<rt-dropdown #dropdown [width]="DropdownWidth.Medium" margin-bottom-small-xx>
  <rt-dropdown-header [fullWidthTitle]="true" class="send-later-header">
    {{ timezoneText }}
  </rt-dropdown-header>
  @if (pickedDate.date) {
    <rt-dropdown-item (click)="pickedSuggestedDate.emit({ moment: pickedDate.sendAt! })">
      <div layout-vertical>
        <div class="line-header">
          {{ 'app.mailbox.send_later_last_set' | translate }}
        </div>
        <div text-dark class="line-suffix">{{ pickedDate.date }}</div>
      </div>
    </rt-dropdown-item>
  }
  @if (!pickedDate.date && lastSetSendLater) {
    <rt-dropdown-item
      (click)="
        pickedSuggestedDate.emit({
          moment: lastSetSendLater.moment!,
          timezone: lastSetSendLater.timezone,
        })
      "
    >
      <div layout-vertical>
        <div class="line-header">
          {{ 'app.mailbox.send_later_last_set' | translate }}
        </div>
        <div text-dark class="line-suffix">
          {{ lastSetSendLater.date }}
        </div>
      </div>
    </rt-dropdown-item>
  }
  @for (dateProposal of datesProposal; track trackByValue($index, dateProposal)) {
    <rt-dropdown-item (click)="pickedSuggestedDate.emit({ moment: dateProposal.moment! })">
      <div layout-vertical>
        <div class="line-header">{{ dateProposal.translation }}</div>
        <div text-dark class="line-suffix">{{ dateProposal.date }}</div>
      </div>
    </rt-dropdown-item>
  }
  <rt-dropdown-item [targetFor]="timePickerTemplate" [hasChevronRight]="true">
    <rt-icon prefix name="calendar-today" />
    {{ 'app.mailbox.send_later_schedule' | translate }}
  </rt-dropdown-item>
</rt-dropdown>

<ng-template #timePickerTemplate>
  <rt-dropdown-header>
    <rt-icon-button
      (click)="$event.preventDefault(); dropdown.prevTemplate()"
      iconName="arrow-back"
      shape="square"
      size="small"
      variant="plain"
      prefix
    />
    {{ 'app.mailbox.send_later_schedule' | translate }}
  </rt-dropdown-header>
  <div layout-vertical layout-full-width layout-justify-center>
    <rt-time-picker
      (valueChange)="timePickerValueChanges($event)"
      (isTimeValid)="onTimeValidationChanges($event)"
      [defaultDate]="defaultData.date"
      [defaultTime]="defaultData.time"
      [defaultTimeZoneName]="defaultData.zone"
      [timeInterval]="15"
      [showDoneButton]="false"
      [blockPastTime]="true"
      direction="today-future"
    />
    <rt-divider margin-top-small-xx />
    <div layout layout-justify-flex-end padding-tb-medium padding-lr layout-full-width>
      <rt-button (click)="dropdown.prevTemplate()" variant="plain">{{
        'app.common.cancel' | translate
      }}</rt-button>
      <rt-button
        variant="primary"
        [disabled]="!isTimeValid"
        margin-left-small-x
        (click)="sendLater()"
        >{{ 'app.mailbox.schedule' | translate }}</rt-button
      >
    </div>
  </div>
</ng-template>
